module.exports = __webpack_public_path__ + "img/65B.9c4e7ae1.png";